import React from 'react'
import './index.less'
import SharingUserInfo from '../sharing-user-info'
import SharingRejectModal from '../sharing-reject-modal'
import { trackGdp } from '../../../../utils/gio-report'
import { Button, Space } from '@xp-design/mobile';

interface SharingApplyItemPropsRule {
    data: any
    key: any
    rejectReason: any[]
    reject: (id: string) => void
    agree: (id: string) => void
}

const SharingApplyItem = (props: SharingApplyItemPropsRule) => {
    const { data, key, reject, agree } = props
    const [loading, setLoading] = React.useState(false)
    const [agreeLoading, setAgreeLoading] = React.useState(false)
    const clickReject = () => {
        trackGdp('P20075', 'B040')
        reject(data.applyReqId)
    }

    const clickAgree = async () => {
        setAgreeLoading(true)
        trackGdp('P20075', 'B039')
        await agree(data)
        setAgreeLoading(false)
    }

    const getApplyDescByStatus = () => {
        switch (data?.applyStatus) {
            case 1:
                return (<div className='header-right-btn'>
                    <Button size='small' variant='text'className='reject' disabled={agreeLoading} onClick={clickReject}>拒绝</Button>
                    <Button size='small' className='agree' loading={agreeLoading}  onClick={clickAgree}>同意</Button>
                </div>)
            case 2:
                return <div className='status-desc' style={{ color: '#5A960A' }}>已通过</div>
            case 3:
                return <div className='status-desc' style={{ color: '#FF4D4F' }}>已拒绝</div>
            case 4:
                return <div className='status-desc' style={{ color: 'rgba(0, 0, 0, 0.25)' }}>已失效</div>
            case 5:
                return <div className='status-desc' style={{ color: 'rgba(0, 0, 0, 0.25)' }}>已取消</div>
            case 6:
                return <div className='status-desc' style={{ color: 'rgba(0, 0, 0, 0.25)' }}>已取消</div>
            default:
                return null
        }
    }
    return <div className='sharing-apply-item' key={key}>
        <div className='header'>
            <SharingUserInfo data={data} />
            <div className='header-right'>
                {getApplyDescByStatus()}
            </div>
        </div>
        <div className='apply-illustrate'>
            <p className='apply-illustrate-text'>
                <p className='label'>申请说明:</p>
                {data?.applyDesc || '--'}
            </p>
        </div>
        <div className='sharing-apply-item-footer'>
            <div className='time'>{data?.applyTime || '--'}</div>
            {
                data?.applyStatus === 1 && (
                    <div className='invalid-tip'>
                        {data?.remainHour <= 0 ? '即将失效' : `${data?.remainHour}小时后失效`}
                    </div>
                )
            }
        </div>
    </div>

}

export default SharingApplyItem